<template>
  <div :class="{ 'entry-where-some-input': buttonView,'entry-where-many-input': many && !buttonView, 'entry-where-one-input': !many && !buttonView, 'd-inline': buttonView }">
    <span v-if="!buttonView" class="form-control h-auto" v-b-modal="`select-${modalID}`">
      <template v-if="many && Array.isArray(results) && results.length">
        <option-component v-for="option in results" :key="option.id" :type="type" :option="option"/>
      </template>
      <option-component v-else-if="!many && results && results.id" :type="type" :option="results"/>
      <option-component v-else :type="type" :option="emptyValue"/>
    </span>
    <b-button
      v-else
      size="md"
      variant="outline-primary"
      v-b-modal="`select-${modalID}`"
    >
      <font-awesome-icon :icon="buttonIcon"/>
      <span class="d-inline d-sm-inline-block">
        {{ buttonText }}
      </span>
    </b-button>
    <b-modal hide-header hide-footer lazy :id="`select-${modalID}`" size="xl" v-if="validType">
      <manage-list :entryType="type" :modal-opts="{ many, title, value: results, where, order }"
        @modal-close="() => $bvModal.hide(`select-${modalID}`)"
        @modal-selected="onEntriesSelected"/>
    </b-modal>
  </div>
</template>

<script>
import models from '@/models';

export default {
  props: {
    type: {
      type: String,
      validate: key => models.hasOwnProperty(key),
    },
    title: {
      type: String,
      default: 'Entries',
    },
    placeholder: {
      type: String,
      default: null,
    },
    many: {
      type: Boolean,
      default: false,
    },
    where: {
      type: Object,
      default: null,
    },
    order: {
      type: String,
      default: null,
    },
    value: {
      type: [ Object, Array ],
      default: null,
    },
    buttonView: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      default: 'Select Existing'
    },
    buttonIcon: {
      type: String,
      default: 'plus'
    },
  },
  components: {
    ManageList: () => import('@src/views/manage/list'),
    OptionComponent: {
      functional: true,
      props: {
        type: String,
        option: [ Object, Array ],
      },
      render(el, { props: { type, option } }) {
        if (models[type] && typeof models[type].option === 'function') {
          const { option: format } = models[type];
          return format(el, option);
        } else {
          const { id, name, title } = option;
          const icon = option.icon || (models[type] ? models[type].icon : null) || null;
          return el('div', { class: 'd-flex flex-row justify-content-start align-items-center' }, [
            icon
              ? el('span', { class: 'bg-dark text-white rounded-circle mr-1' }, [
                el('font-awesome-icon', { class: 'mx-1', props: { icon, fixedWith: true, size: 'sm' } }),
              ])
              : null,
            el('span', { class: 'd-block' }, title || name || `${type} ${id}`),
          ]);
        }
      },
    },
  },
  data() {
    return { results: null };
  },
  watch: {
    value: {
      handler(value) {
        if (Array.isArray(value) && value.length) {
          this.results = value;
        } else if (value) {
          this.results = value;
        }
      },
      immediate: true,
    },
  },
  computed: {
    modalID() {
      return this._uid;
    },
    emptyValue() {
      const { emptyOptionValue } = models[this.type] ? (models[this.type].listSchema || {}) : {};
      if (typeof emptyOptionValue === 'function') {
        return emptyOptionValue.call(this);
      } else {
        return emptyOptionValue || { icon: this.many ? 'check-double' : 'check', title: 'Click to choose' };
      }
    },
    validType() {
      return models.hasOwnProperty(this.type);
    },
  },
  methods: {
    onEntriesSelected(entries) {
      if (this.many) {
        this.results = entries.length ? entries : null;
      } else {
        this.results = entries.length ? entries.shift() : null;
      }
      this.$emit('input', this.results);
    },
  },
};
</script>

<style lang="scss">
.entry-where-some-input {
  > .form-control {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/manage/EntryWhereSomeInput.vue